export default "__VITE_ASSET__VfJm2ZZKT9OX2CjveQ8jRA__"